var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("基本配置")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("部门管理")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "box" },
        [
          _c(
            "div",
            { staticClass: "el-menu-input" },
            [
              _c("div", { staticClass: "titleBox" }, [
                _vm._m(0),
                _c("i", {
                  staticClass: "el-icon-refresh",
                  staticStyle: { cursor: "pointer" },
                  on: { click: _vm.treeAxios },
                }),
              ]),
              _c("el-input", {
                attrs: { placeholder: "输入关键字进行查询" },
                model: {
                  value: _vm.filterText,
                  callback: function ($$v) {
                    _vm.filterText = $$v
                  },
                  expression: "filterText",
                },
              }),
              _c("el-tree", {
                ref: "tree",
                staticClass: "el-menu-vertical-demo",
                attrs: {
                  data: _vm.departmentList,
                  props: _vm.defaultProps,
                  "highlight-current": true,
                  "filter-node-method": _vm.filterNode,
                },
                on: { "node-click": _vm.handleNodeClick },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "inquiryTab" }, [
            _c("div", { staticClass: "titleBox" }, [
              _c("div", { staticClass: "division" }),
              _c("div", { staticClass: "left_title" }, [_vm._v("部门列表")]),
              _c("div", { staticClass: "btn-list tabclass" }, [
                _c(
                  "div",
                  {},
                  [
                    _vm.parArray.indexOf("bmAdd") != -1
                      ? _c(
                          "el-button",
                          {
                            staticClass: "ml100",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.showDialog("新增", "add")
                              },
                            },
                          },
                          [_vm._v("新增")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "table" },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      border: "",
                      "header-cell-style": { background: "#f8f8f8" },
                      data: _vm.tableData,
                      align: "center",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "部门名称", prop: "orgName" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "部门编号", prop: "orgCode" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "部门成员" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "p",
                                {
                                  staticClass: "pointer",
                                  style: {
                                    color: props.row.status == "S" ? "red" : "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.staffDetails(props.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(props.row.peopleCount) + " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "组织类型", prop: "phoneNumber" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return _vm.dictionariesList.length > 0
                                ? [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "请选择" },
                                        on: {
                                          change: function ($event) {
                                            return _vm.org(props.row)
                                          },
                                        },
                                        model: {
                                          value: props.row.type,
                                          callback: function ($$v) {
                                            _vm.$set(props.row, "type", $$v)
                                          },
                                          expression: "props.row.type",
                                        },
                                      },
                                      _vm._l(
                                        _vm.dictionariesList,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.dictId,
                                            attrs: {
                                              label: item.dictName,
                                              value: item.dictId,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ]
                                : undefined
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "排序", prop: "sort" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "更新时间",
                        prop: "updatedTime",
                        width: "300",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "状态", prop: "status" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "p",
                                {
                                  style: {
                                    color:
                                      props.row.status == "S"
                                        ? "red"
                                        : "" || props.row.status == "A"
                                        ? "#67C23A"
                                        : "" || props.row.status == "X"
                                        ? "#999999"
                                        : "",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(props.row.statusName) + " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作", prop: "status" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "p",
                                [
                                  _vm.parArray.indexOf("updateOrg") != -1
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "ml100",
                                          attrs: {
                                            size: "small",
                                            type: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showDialog(
                                                "修改",
                                                "edit",
                                                props.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" 修改 ")]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "ml100",
                                      attrs: { size: "small", type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.delectTeam(props.row)
                                        },
                                      },
                                    },
                                    [_vm._v(" 删除 ")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm.totalNum > 0
            ? _c("div", { staticClass: "page" }, [
                _c(
                  "div",
                  { staticClass: "block" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.pageNo,
                        "page-sizes": [10, 20, 50, 100, 200],
                        "page-size": _vm.pageSize,
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.totalNum,
                        "prev-text": "上一页",
                        "next-text": "下一页",
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange,
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "部门成员",
                visible: _vm.dialogVisible,
                "append-to-body": true,
                width: "45%",
                "before-close": _vm.handleClose,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "dialogtable" },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        align: "center",
                        data: _vm.dialogDateList,
                        "header-cell-style": { background: "#f8f8f8" },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "姓名",
                          "min-width": "100",
                          prop: "name",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "手机号",
                          "min-width": "100",
                          prop: "phoneNumber",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "角色", "min-width": "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(props.row.roleNameList.toString())
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm.totalNum > 0
                    ? _c("div", { staticClass: "pageDialog" }, [
                        _c(
                          "div",
                          { staticClass: "block" },
                          [
                            _c("el-pagination", {
                              attrs: {
                                "current-page": _vm.pageNoDialog,
                                "page-sizes": [10, 20, 50, 100, 200],
                                "page-size": _vm.pageSizeDialog,
                                layout:
                                  "total, sizes, prev, pager, next, jumper",
                                total: _vm.dialogTotalNum,
                                "prev-text": "上一页",
                                "next-text": "下一页",
                              },
                              on: {
                                "size-change": _vm.handleDialogSizeChange,
                                "current-change": _vm.handleDialogCurrentChange,
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "company-dialog",
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: "30%",
            "append-to-body": true,
            "before-close": _vm.handleCloseEdit,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-content" }, [
            _c(
              "div",
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: { model: _vm.form, "label-width": "100px" },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "上级部门", prop: "parentOrgName" } },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: "",
                            size: "mini",
                            maxlength: "20",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.form.parentOrgCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "parentOrgCode", $$v)
                            },
                            expression: "form.parentOrgCode",
                          },
                        }),
                        _c("el-input", {
                          attrs: {
                            disabled: "",
                            size: "mini",
                            maxlength: "20",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.form.parentOrgName,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "parentOrgName", $$v)
                            },
                            expression: "form.parentOrgName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "部门名称", prop: "orgName" } },
                      [
                        _vm.form.dingId
                          ? _c("el-input", {
                              attrs: {
                                disabled: "",
                                size: "mini",
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.form.orgName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "orgName", $$v)
                                },
                                expression: "form.orgName",
                              },
                            })
                          : _vm._e(),
                        !_vm.form.dingId
                          ? _c("el-input", {
                              attrs: { size: "mini", "show-word-limit": "" },
                              model: {
                                value: _vm.form.orgName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "orgName", $$v)
                                },
                                expression: "form.orgName",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "部门编号", prop: "orgCode" } },
                      [
                        _vm.form.dingId
                          ? _c("el-input", {
                              attrs: {
                                disabled: "",
                                size: "mini",
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.form.orgCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "orgCode", $$v)
                                },
                                expression: "form.orgCode",
                              },
                            })
                          : _vm._e(),
                        !_vm.form.dingId
                          ? _c("el-input", {
                              attrs: { size: "mini", "show-word-limit": "" },
                              model: {
                                value: _vm.form.orgCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "orgCode", $$v)
                                },
                                expression: "form.orgCode",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "排序", prop: "sort" } },
                      [
                        _c("el-input", {
                          attrs: { size: "mini", "show-word-limit": "" },
                          model: {
                            value: _vm.form.sort,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "sort", $$v)
                            },
                            expression: "form.sort",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "类型", prop: "type" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.form.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "type", $$v)
                              },
                              expression: "form.type",
                            },
                          },
                          _vm._l(_vm.dictionariesList, function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "状态", prop: "status" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "status", $$v)
                              },
                              expression: "form.status",
                            },
                          },
                          _vm._l(_vm.dictionaries.data_status, function (item) {
                            return item.dictId !== "X"
                              ? _c(
                                  "el-radio",
                                  {
                                    key: item.dictId,
                                    attrs: {
                                      value: item.dictId,
                                      label: item.dictId,
                                      name: item.dictId,
                                    },
                                  },
                                  [_vm._v(_vm._s(item.dictName) + " ")]
                                )
                              : _vm._e()
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialog.visible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleSubmitEdit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticStyle: { display: "flex", "align-items": "center" } },
      [
        _c("div", { staticClass: "division" }),
        _c("div", { staticClass: "left_title" }, [_vm._v("选择部门")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }